import React from "react";
import logo from "../../assets/images/logo/logo.png";
import { withTranslation } from 'react-i18next';

const FooterTwo = ({ t }) => {
  const year = new Date().getFullYear();

  return (
    <div
      className="footer-style-2 ptb--30 bg_image bg_image--2"
      data-black-overlay="1"
    >
      <div className="wrapper plr--50 plr_sm--20">
        <div className="row align-items-center justify-content-between">
          <div className="col-lg-4 col-md-6 col-sm-6 col-12">
            <div className="inner">
              <div className="logo text-center text-sm-left mb_sm--20">
                <a href="/home-one">
                  <img src={logo} alt="Logo images" />
                </a>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12 col-12">
            <div className="inner text-lg-right text-center mt_md--20 mt_sm--20">
              <div className="text">
                <p>
                  {t("Derechos")} © {year} <br />
                  {t("Desarrollo")}&nbsp;
                  <a
                    href="https://www.linkedin.com/in/sebastianuxcode/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Sebastian Valencia
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(FooterTwo);
